import { Typography } from "antd"

import "./BrandTag.less"

const { Text } = Typography

const BrandTag = ({ label, image }) => {
  return (
    <span className="brand-tag">
      <img width={16} height={16} src={image} alt={label} />
      <Text className="brand-tag__label">{label}</Text>
    </span>
  )
}

export default BrandTag
